import { ValidationModifierType } from 'parkchirp-shared';
import { PermissionFunctionGroup } from './permissions';

export enum HourlyQueryContextEnum {
	TABLE = 'TABLE',
	AUTOCOMPLETE = 'AUTOCOMPLETE',
}

export interface HourlyAccount {
	id?: string;
	pid?: string;
	name?: string;
	description?: string;
	facility?: {
		id: string;
		facilityName: string;
		facilityNumber: string;
	};
	organizationSettings?: {
		name?: string;
		organizationId: number;
	};
	hourlyAccountConfigs?: HourlyAccountConfig[];
}

export interface HourlyAccountUser {
	id?: number;
	active?: boolean;
	user?: {
		userId: string;
		firstName: string;
		lastName: string;
		email: string;
	};
	hourlyAccount?: HourlyAccount;
	hourlyAccountUserGroup?: HourlyAccountUserGroup;
}

export interface HourlyAccountUserGroup {
	id?: string;
	masterPolicy?: boolean;
	hourlyAccount?: HourlyAccount;
	userGroup?: {
		name?: string;
		functionGroups: PermissionFunctionGroup[];
	};
	validationMethods?: HourlyAccountUserGroupValidation[];
}

export interface HourlyAccountUserGroupValidation {
	id: string;
	webValidation: boolean;
	qrValidation: boolean;
	validationMethod: {
		id: string;
		text: string;
		startsOn: string;
		expiresOn: string;
		hourlyValidation: {
			id: string;
			name: string;
			modifier: {
				type: ValidationModifierType;
				value: number;
				rate: {
					id: string;
					name: string;
				};
			};
		};
	};
}

export interface HourlyAccountConfig {
	id: string;
	feature: string;
	config: string;
	createdAt: string;
	updatedAt: string;
}
